const Button = ({label, onClick, disabled=false}) => {
    return <button type="button" onClick={onClick} disabled={disabled} className="btn">{label}</button>
}

export default Button;